import { useMutation } from "react-query";
import AttToken from "../../services/AttToken";
import Empresas from "../../services/Empresas";
import queryClient from "../../services/query";
import { toast } from "react-toastify";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField } from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { empresaType } from "../../context/EmpresasContext";

const empresaService = new Empresas();

export default function AddPathModal({
  openModalDominio,
  setOpenModalDominio,
  selectedEmpresa
}:
  {
    openModalDominio: boolean,
    setOpenModalDominio: Function,
    selectedEmpresa: empresaType
  }) {
  const [dominio, setDominio] = useState<string>('')

  const { mutate, isLoading } = useMutation({
    mutationKey: ['ADD_DOMINIO'],
    mutationFn: async () => {
      try {
        const token = await AttToken()
        if (token) {
          const response = await empresaService.setDominio(
            token,
            selectedEmpresa?.id as string,
            dominio
          )
          queryClient.resetQueries(['GET_EMPRESAS'])
          setOpenModalDominio(!openModalDominio)
          return response
        }
      } catch (err) {
        toast.error("Erro ao cadastrar!", {
          position: "top-right",
          autoClose: 5000,
          closeOnClick: true,
          theme: "colored",
        })
      }
    },
    onSuccess: () => {
      toast.success('Dominio cadastrado!', {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        theme: "colored",
      })
    },
    onError: () => {
      toast.error("Erro ao cadastrar!", {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        theme: "colored",
      })
    }
  })

  function checkChar(value: string): undefined | string {
    if (value === '') {
      return ''
    }
    const pattern = /^[A-Za-z]+$/;
    if (pattern.test(value)) {
      return value;
    }
    return
  }

  return (
    <Dialog
      onClose={() => setOpenModalDominio(!openModalDominio)}
      aria-labelledby="customized-dialog-title"
      open={openModalDominio}
    >
      <DialogTitle sx={{ m: 0, p: 2, width: '500px' }} id="customized-dialog-title">
        Adicionar domínio
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpenModalDominio(!openModalDominio)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack direction='column' spacing={2} alignItems='baseline' justifyContent='flex-start' padding={2}>
          <TextField
            fullWidth
            type="text"
            inputProps={{ maxLength: 8 }}
            value={dominio}
            onChange={
              (even) => {
                const domValue = checkChar(even.target.value)
                if (domValue === undefined) return;
                setDominio(domValue)
              }}
            label='Dominio'
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={() => mutate()} disabled={isLoading || !dominio?.length}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
